import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, {
    style: _ctx.rolesCardDescriptor.card.style
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('managers.newsManagement.roles')), 1)
        ]),
        _: 1
      })
    ]),
    content: _withCtx(() => [
      _createVNode(_component_DataTable, {
        value: _ctx.categoryList,
        selection: _ctx.selectedCategories,
        "onUpdate:selection": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedCategories = $event)),
        class: "p-datatable-sm kn-table",
        dataKey: "id",
        rows: 20,
        scrollable: true,
        scrollHeight: _ctx.rolesCardDescriptor.table.scrollHeight,
        responsiveLayout: "stack",
        breakpoint: "960px",
        onRowSelect: _ctx.setDirty,
        onRowUnselect: _ctx.setDirty,
        onRowSelectAll: _ctx.onSelectAll,
        onRowUnselectAll: _ctx.onUnselectAll,
        "data-test": "data-table"
      }, {
        empty: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            field: "name",
            header: _ctx.$t('managers.newsManagement.role'),
            style: _ctx.rolesCardDescriptor.column.header.style
          }, null, 8, ["header", "style"]),
          _createVNode(_component_Column, {
            selectionMode: "multiple",
            style: _ctx.rolesCardDescriptor.column.style,
            dataKey: "id"
          }, null, 8, ["style"])
        ]),
        _: 1
      }, 8, ["value", "selection", "scrollHeight", "onRowSelect", "onRowUnselect", "onRowSelectAll", "onRowUnselectAll"])
    ]),
    _: 1
  }, 8, ["style"]))
}